import Vue from 'vue'
import advancedSearchForm from "./components/advancedSearch/advancedSearchForm.vue";
import advancedUmkreisForm from "./components/advancedUmkreissuche/advancedUmkreisForm.vue";

const classes = document.getElementsByClassName('wpi');

for (const element of classes) {
	new Vue({
		components: {
			advancedSearchForm,
			advancedUmkreisForm
		}
	}).$mount(element);
}
